/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Result/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AssignAction from './AssignAction/index'
import BillingCenter from './BillingCenter/index'
import Carrier from './Carrier/index'
import DetailsAction from './DetailsAction/index'
import Employer from './Employer/index'
import Number from './Number/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Result({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/SearchTable/Content/Result"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Result.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2bDUvM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z2bDUvM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
<BillingCenter
  viewPath={`${viewPath}/BillingCenter`}
/>
<Carrier
  viewPath={`${viewPath}/Carrier`}
/>
<Employer
  viewPath={`${viewPath}/Employer`}
/>
<div
  data-testid="Result.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<DetailsAction
  viewPath={`${viewPath}/DetailsAction`}
/>
<AssignAction
  viewPath={`${viewPath}/AssignAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}